class OperationsPopup {
  constructor() {
    const popup = document.querySelector('.operations-popup');
    const close = document.querySelector('.js-operations-popup-close');

    if (popup) {
      close.addEventListener('click', () => {
        location.hash = '';
        popup.classList.remove('active');
      });

      window.addEventListener('hashchange', () => {
        if (location.hash.startsWith('#operations-popup')) {
          popup.classList.add('active');
        }
        else {
          popup.classList.remove('active');
        }
      });

      window.addEventListener('keydown', e => {
        if (popup.classList.contains('active') && e.key == 'Escape') {
          location.hash = '';
          popup.classList.remove('active');
        }
      });

      popup.addEventListener('click', e => {
        if (e.target == popup) {
          location.hash = '';
          popup.classList.remove('active');
        }
      });

      const buttons = document.querySelectorAll('.operations-popup__documents__button');
      const links = document.querySelectorAll('.operations-popup__documents__links');

      buttons.forEach(target => {
        target.addEventListener('click', () => {
          buttons.forEach(button => {
            target == button ? button.classList.add('active') : button.classList.remove('active');
          });

          links.forEach(link => {
            target.dataset.group == link.dataset.group ? link.classList.add('active') : link.classList.remove('active');
          });
        });
      });
    }
  }
}

export default OperationsPopup;
